module.exports = __webpack_public_path__ + "static/media/zUSDC.bb8af01b.png";